import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext(null);

function hexToRgb(hex) {
  const clean = (hex || "#0F172A").replace("#", "");
  const bigint = parseInt(clean.length === 3
    ? clean.split("").map((c) => c + c).join("")
    : clean, 16);
  return `${(bigint >> 16) & 255} ${(bigint >> 8) & 255} ${bigint & 255}`;
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    company_name: "Acme CRM",
    theme_color: "#0F172A",
    logo_url: null,
    favicon_url: null,
    address: "",
    email: "",
    phone: "",
    copyright: "",
  });

  const apply = (b) => {
    if (b?.theme_color) {
      document.documentElement.style.setProperty("--theme-color", b.theme_color);
      document.documentElement.style.setProperty("--theme-color-rgb", hexToRgb(b.theme_color));
    }
    if (b?.sidebar_color) {
      document.documentElement.style.setProperty("--sidebar-color", b.sidebar_color);
    } else {
      document.documentElement.style.removeProperty("--sidebar-color");
    }
    if (b?.header_color) {
      document.documentElement.style.setProperty("--header-color", b.header_color);
    } else {
      document.documentElement.style.removeProperty("--header-color");
    }
    if (b?.company_name) {
      document.title = b.company_name;
    }
    if (b?.favicon_url) {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = b.favicon_url;
    }
  };

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding(data);
      apply(data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = async (next) => {
    const { data } = await api.put("/branding", next);
    setBranding(data);
    apply(data);
    return data;
  };

  return (
    <BrandingContext.Provider value={{ branding, refresh, save }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
